var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishClubTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.32,
    viewBox: "0 0 18 15.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "English_Club_TV",
    "data-name": "English Club TV",
    transform: "translate(-3.027 -4.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4268",
    "data-name": "Rectangle 4268",
    transform: "translate(3.027 7.763)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12,
    rx: 2,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 11,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9005",
    "data-name": "Path 9005",
    d: "M13.227,3,10.613,5.613,8,3",
    transform: "translate(1.543 2.149)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishClubTv);
export default __webpack_public_path__ + "static/media/English-Club-TV.a7b70ab8072c3723b1c7f8e3d04943b5.svg";
export { ForwardRef as ReactComponent };